module.exports = "<app-payments-amount></app-payments-amount>\n<app-payments-count></app-payments-count>\n"